
import { gsap } from 'gsap'

export default function hover () {
  return {
    bind (el, data) {
      el.addEventListener('mouseenter', function () {
        gsap.to('.pointer', { className: '+=hover pointer' })
      })
      el.addEventListener('mouseleave', function () {
        gsap.to('.pointer', { className: '-=pointer' })
      })
    }
  }
}
